import { fetchLensExamDetail, fetchLensExamHistory, deleteLensPatientRecords } from '../../utils/lensRecommend';
import { extractHistoryRows } from './historyHelpers';
import { toLatestListRows } from './v2Helpers';

/**
 * 차트번호로 렌즈추천 히스토리를 조회한다.
 */
export async function fetchListByChart({ chartNo, hospitalId, startDt, endDt }) {
  const response = await fetchLensExamHistory({
    chartNo,
    hospitalId,
    startDt,
    endDt,
    chartNoLike: true
  });
  return toLatestListRows(extractHistoryRows(response));
}

/**
 * 렌즈추천 히스토리를 조회한다.
 */
export async function fetchRevisionHistory({
  chartNo,
  hospitalId,
  startDt,
  endDt,
  actionType,
  caseId
}) {
  const response = await fetchLensExamHistory({
    chartNo,
    hospitalId,
    startDt,
    endDt,
    actionType,
    caseId
  });
  return extractHistoryRows(response);
}

// JSON 컬럼은 드라이버 설정에 따라 객체 또는 문자열로 내려올 수 있다.
function parseJsonColumn(value, fallback) {
  if (value === null || value === undefined) return fallback;
  if (typeof value !== 'string') return value;

  try {
    const parsed = JSON.parse(value);
    return parsed === null ? fallback : parsed;
  } catch (error) {
    return fallback;
  }
}

/**
 * 저장된 실행 이력에서 추천 리포트(결과/사이즈 비교/유사 케이스/경고)를 복원한다.
 */
export async function fetchSavedReport({ examId, hospitalId }) {
  const response = await fetchLensExamDetail({ examId, hospitalId });
  const row = response?.result;
  if (!row) return null;

  return {
    examId: row.examId,
    examDt: row.examDt,
    actionType: row.actionType,
    result: parseJsonColumn(row.resultJson, null),
    sizeCompare: parseJsonColumn(row.compareJson, []) || [],
    similarCases: parseJsonColumn(row.similarCasesJson, []) || [],
    warnings: parseJsonColumn(row.warningsJson, []) || []
  };
}

export async function deletePatientFromList({ caseId, chartNo, eye, hospitalId }) {
  return deleteLensPatientRecords({ caseId, chartNo, eye, hospitalId });
}

export { formatDate } from './v2Helpers';
